






















import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { generalDialogMixin, elementWidth } from '@/mixins'
import easyapi from '@/easyapi'
import { deepCopy, magicCode2Text, rotateFlipToIgClass } from '@/utils'
import VwResizePreview from '@/components/VwResizePreview.vue'
import IgIcon from '@/components/IgIcon.vue'
import { VW_MAX_COLUMNS, VW_MAX_ROWS } from '@/vw_algorithm'
import { ApiVwBezel, RotateFlip, ApiVwRx } from '@/types/api'
import { PropValidator } from 'vue/types/options'

export default mixins(generalDialogMixin, elementWidth).extend({
  components: {
    VwResizePreview,
    IgIcon
  },
  props: {
    show: {
      type: Boolean
    },
    initialValue: { } as PropValidator<ApiVwRx|null>
  },
  data (): {
    imgWidth: number,
    bezel: ApiVwBezel,
  } {
    return {
      imgWidth: 0,
      bezel: {
        ow: 0,
        oh: 0,
        iw: 0,
        ih: 0,
      },
    }
  },
  computed: {
  },
  methods: {
    async apply () {
      // string to number......
      const bezel = {}
      for (const key in this.bezel) {
        bezel[key] = ~~this.bezel[key]
      }
      this.$emit('apply', bezel)
      this.closeThisDialog()
    }
  },
  watch: {
    show (nv: boolean) {
      if (nv) {
        if (!this.initialValue) {
          console.warn('[To Developer] Please provide a RX as initial value (:initialValue="aRx") to Bezel')
        } else {
          Object.assign(this.bezel, this.initialValue.bezel)
        }
      }
    }
  },
  mounted () {
    this.watchElementWidth('imgContainer', ['show'])
  }
})
